import React, { Component, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slick.css";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";

const settings = {
  dots: true,
  infinite: true,
  arrow: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const MobileCarousel = ({ images, cartHasItem, userType, navigate }) => {
  const [open, setOpen] = useState(false);
  return (
    <SliderContainer>
      <div
        style={{
          position: "absolute",
          top: "0",
          right: 0,
          color: Colors.white,
          zIndex: 999,
          padding: "1rem",
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        <div
          onClick={() => setOpen(!open)}
          style={{ textAlign: "right", width: "32px", height: "32px" }}
        >
          {open ? (
            <img
              src={require("../../assets/icons/icn-white-close.png")}
              style={{ width: "24px" }}
            />
          ) : (
            <img src={require("../../assets/icons/Icn_Menu.png")} />
          )}
        </div>
        {open && (
          <div
            style={{
              background: "white",
              borderRadius: "8px",
              textAlign: "right",
              padding: "8px",
            }}
          >
            {cartHasItem > 0 && (
              <div
                onClick={() => navigate("/app/cart")}
                style={{ padding: "8px", color: "#000" }}
              >
                My Cart ({cartHasItem})
              </div>
            )}
            {["guest"].includes(userType) ? (
              <div
                onClick={() => navigate("/auth/login")}
                style={{ padding: "8px", color: "#000" }}
              >
                Sign In
              </div>
            ) : (
              <div
                onClick={() => {
                  navigate("/auth/login");
                  localStorage.removeItem("token");
                  localStorage.removeItem("user");
                  localStorage.removeItem("type");
                  localStorage.removeItem("name");
                  localStorage.removeItem("refreshToken");
                  localStorage.removeItem("guestSigned");
                }}
                style={{ padding: "8px", color: "#000" }}
              >
                Sign Out
              </div>
            )}
          </div>
        )}
      </div>
      <Slider {...settings}>
        {images?.map((item) => (
          <SliderImageContainer>
            <SliderImage src={item.url} alt={item.alt} />
          </SliderImageContainer>
        ))}
      </Slider>
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  display: none;
  @media only screen and (max-width: 1024px) {
    display: block;
    position: relative;
  }
`;
const SliderImageContainer = styled.div``;
const SliderImage = styled.img`
  height: 15rem;
  object-fit: cover;
  width: 100%;
`;

export default MobileCarousel;
